import Image from '@base/Image';
import styled from '@emotion/styled';
import { Fonts, Spacings } from '@styles/index';
import P1 from '@base/P1/P1';

const StaticInfoOfferingsWrapper = styled.div`
  display: flex;
  flex-direction: column;
  align-items: start;
  gap: ${Spacings.SPACING_6B};
  margin-bottom: 24px;
`;

const OfferingWrapper = styled.div`
  display: flex;
  align-items: start;
  img {
    padding-top: ${Spacings.SPACING_2} !important;
  }
`;

const OfferingText = styled(P1)`
  color: var(--color-i-black);
  font-size: ${Fonts.P1};
  font-weight: ${Fonts.SEMIBOLD};
  padding-left: ${Spacings.SPACING_2B};
  line-height: ${Spacings.SPACING_18};
  max-width: 85%;
`;

const EnquiryStaticInfoOfferings = () => {
  const offerings = [
    'Learn face-to-face from the best educators in your city',
    'Access high-tech library, spacious classrooms, cafe and more',
    'Regular educator-parent connect'
  ];

  return (
    <StaticInfoOfferingsWrapper>
      {offerings?.map((offering, index) => (
        <OfferingWrapper key={String(index)}>
          <Image
            src="offline-centres/bullet-checkbox.svg"
            width={18}
            height={18}
            alt="check rounded"
          />
          <OfferingText>{offering}</OfferingText>
        </OfferingWrapper>
      ))}
    </StaticInfoOfferingsWrapper>
  );
};

export default EnquiryStaticInfoOfferings;
